<script setup>
import { Link } from '@inertiajs/vue3'
import Feature from '../Badges/Feature.vue'

defineProps({
  title: {
    type: String,
  },
  counter: {
    type: [Number, String],
    default: 0,
  },
  href: {
    type: String,
    default: '#',
  },
  icon: {
    required: true,
  },
  enabled: {
    type: Boolean,
    default: true,
  },
  inertia: {
    type: Boolean,
    default: false,
  },
  feature: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String,
    default: 'top-0 md:-right-0.5',
  },
})
</script>

<template>
  <component
    :is="inertia ? Link : 'a'"
    v-if="enabled"
    :href="href"
    class="flex flex-col items-center text-xs justify-center relative"
  >
    <component :is="icon" class="md:w-8 md:h-8 h-6 w-6" />
    <span class="hidden md:block">
      {{ title }}
    </span>

    <div v-if="counter && counter > 0">
      <span
        class="absolute bg-red-500 text-xs text-white rounded-md px-1"
        :class="position"
      >
        {{ counter }}
      </span>
    </div>
    <div v-else-if="feature">
      <div
        class="absolute"
        :class="position"
      >
        <Feature :label="counter" />
      </div>
    </div>
  </component>
</template>
